import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Field, ErrorMessage } from "formik";
import CustomFormTextArea from "../../../../components/customcomponents/CustomFormTextArea";

const Step2Description = ({
    values,
    setFieldValue,
    submitted,
    errors,
    t,
    language,
}) => {
    return (
        <div>
            <Row>
                <Col md={12}>
                    <div className="mb-3">
                        <CustomFormTextArea
                            color={"#222528"}
                            as="textarea"
                            name="short_description"
                            lableText={t("AddProperties.shortDescriptionEnglish")}
                            rows={5}
                            placeholderText={t("AddProperties.enterHere")}
                            onChange={(e) => setFieldValue("short_description", e.target.value)}
                            value={values.short_description}
                        />
                        {submitted && errors.short_description && (
                            <ErrorMessage
                                name="short_description"
                                component="div"
                                className="errorStyle"
                            />
                        )}
                    </div>
                    <div className="mb-3">
                        <CustomFormTextArea
                            color={"#222528"}
                            as="textarea"
                            name="long_description"
                            lableText={t("AddProperties.longDescriptionEnglish")}
                            rows={8}
                            placeholderText={t("AddProperties.enterHere")}
                            onChange={(e) => setFieldValue("long_description", e.target.value)}
                            value={values.long_description}
                        />
                        {submitted && errors.long_description && (
                            <ErrorMessage
                                name="long_description"
                                component="div"
                                className="errorStyle"
                            />
                        )}
                    </div>
                    <div className="mb-3">
                        <CustomFormTextArea
                            color={"#222528"}
                            as="textarea"
                            name="short_description_hebrew"
                            lableText={t("AddProperties.shortDescriptionHebrew")}
                            rows={5}
                            placeholderText={t("AddProperties.enterHere")}
                            onChange={(e) =>
                                setFieldValue("short_description_hebrew", e.target.value)
                            }
                            value={values.short_description_hebrew}
                        />
                        {submitted && errors.short_description_hebrew && (
                            <ErrorMessage
                                name="short_description_hebrew"
                                component="div"
                                className="errorStyle"
                            />
                        )}
                    </div>
                    <div className="mb-3">
                        <CustomFormTextArea
                            color={"#222528"}
                            as="textarea"
                            name="long_description_hebrew"
                            lableText={t("AddProperties.longDescriptionHebrew")}
                            rows={8}
                            placeholderText={t("AddProperties.enterHere")}
                            onChange={(e) =>
                                setFieldValue("long_description_hebrew", e.target.value)
                            }
                            value={values.long_description_hebrew}
                        />
                        {submitted && errors.long_description_hebrew && (
                            <ErrorMessage
                                name="long_description_hebrew"
                                component="div"
                                className="errorStyle"
                            />
                        )}
                    </div>
                    <Form className="radioFlex mb-3 mar">
                        <Field
                            inline
                            label={t("AddProperties.availableForReserving")}
                            name="is_available_for_booking"
                            type="radio"
                            value="reserving"
                            as={Form.Check}
                            onChange={() =>
                                setFieldValue("is_available_for_booking", "reserving")
                            }
                            checked={values.is_available_for_booking == "reserving"}
                        />
                        <Field
                            className={language === "he" ? "checkbox-rtl" : ""}
                            inline
                            label={t("AddProperties.availableOnlyOnContact")}
                            name="is_available_for_booking"
                            type="radio"
                            value="contract"
                            as={Form.Check}
                            onChange={() =>
                                setFieldValue("is_available_for_booking", "contract")
                            }
                            checked={values.is_available_for_booking == "contract"}
                        />
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default Step2Description;
